import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

interface OtpSubheaderProps {
  email?: string;
  isVerifying: boolean;
}

export const OtpSubheader = ({ email, isVerifying }: OtpSubheaderProps) => (
  <div className="flex flex-col gap-2">
    {isVerifying && (
      <Typography.BodySm weight="font-bold">
        {t("otp_challenge_modal.verification_required")}
      </Typography.BodySm>
    )}
    <Typography.BodySm>
      {t("otp_challenge_modal.enter_code_sent_to")}&nbsp;
      {email && (
        <Typography.LabelSm
          as="span"
          color="text-slate-700 dark:text-inherit"
          weight="medium"
        >
          {email}
        </Typography.LabelSm>
      )}
    </Typography.BodySm>
  </div>
);

OtpSubheader.displayName = "OtpSubheader";
